export const searchClinicInitialState = {
  filters: {
    name: "",
    location: "",
    serviceIds: "",
    serviceNames: "",
  },
  currentPage: 1,
  totalPages: 1,
  allClinicList: [],
  isClinicListLoading: false,
};

export const searchClinicReducer = (state, action) => {
  switch (action.type) {
    case "SET_CLINIC_FILTERS":
      return {
        ...state,
        filters: { ...state.filters, ...action.payload },
        currentPage: 1, // reset to page 1 when filters change
      };
    case "SET_CLINIC_PAGE":
      return { ...state, currentPage: action.payload };
    case "SET_CLINIC_DATA":
      return {
        ...state,
        allClinicList: action.payload.data,
        totalPages: action.payload.totalPages,
        isClinicListLoading: false,
      };
    case "SET_CLINIC_LOADING":
      return { ...state, isClinicListLoading: action.payload };
    case "RESET_CLINIC_FILTERS":
      return {
        ...searchClinicInitialState,
      };
    default:
      return state;
  }
};
